(() => {
  const OFFER_ID = "17520";
  const PATCH_KEY = "__salepifyOfferNotificationPatched";

  const OFFER_TEXT = {
    en: {
      header_text: "You've unlocked a free Backpack",
      body_text: "Already added to your cart."
    },
    nl: {
      header_text: "Je gratis Backpack is toegevoegd",
      body_text: "Staat nu in je winkelmand."
    },
    de: {
      header_text: "Dein gratis Backpack ist im Warenkorb",
      body_text: "Bereits zu deiner Bestellung hinzugefugt."
    },
    fr: {
      header_text: "Votre Backpack offert est dans votre panier",
      body_text: "Deja ajoute a votre commande."
    }
  };

  const getLocale = () => (window.Shopify?.locale || "en").toLowerCase().split("-")[0];

  const applyPatch = () => {
    if (!window.tlNotificationPopupClass || !window.tlFreeGiftOffer) return false;

    const popupProto = window.tlNotificationPopupClass.prototype;
    const freeGift = window.tlFreeGiftOffer;

    if (popupProto[PATCH_KEY] || freeGift[PATCH_KEY]) return true;

    popupProto[PATCH_KEY] = true;
    freeGift[PATCH_KEY] = true;

    const originalCreateNotiEle = popupProto.createNotiEle;
    const originalHandleAddGifts = freeGift.handleAddGifts;

    popupProto.showNoti = function (imageSrc, meta = {}) {
      const popup = originalCreateNotiEle.call(this, imageSrc);
      const customText =
        String(meta.offerId || "") === OFFER_ID
          ? OFFER_TEXT[getLocale()] || OFFER_TEXT.en
          : null;

      if (customText) {
        const header = popup.querySelector(".salepify-notification-popup__header");
        const body = popup.querySelector(".salepify-notification-popup__body");

        if (header) header.textContent = customText.header_text;
        if (body) body.textContent = customText.body_text;
      }

      this.containerEle.appendChild(popup);
      setTimeout(() => this.handleShowPopup(popup), 0);
      this.containerEle.scrollTop = this.displaySettings.position.includes("bottom")
        ? this.containerEle.scrollHeight
        : 0;
      setTimeout(() => this.handleHidePopup(popup), this.displaySettings.duration * 1000);
    };

    freeGift.showNotification = function (listImgSrc) {
      const offerIds = Array.isArray(this.__salepifyOfferIdsForNextNotification)
        ? this.__salepifyOfferIdsForNextNotification
        : [];

      if (!this.notification) {
        const { isRestricted, displaySettings, translations } = window.tlFreeGiftData;
        if (!window.tlNotificationPopupClass) return;
        this.notification = new window.tlNotificationPopupClass(isRestricted, displaySettings, translations);
      }

      listImgSrc.forEach((imgSrc, index) => {
        this.notification.showNoti(imgSrc, { offerId: String(offerIds[index] || "") });
      });

      this.__salepifyOfferIdsForNextNotification = [];
    };

    freeGift.handleAddGifts = async function (items, discountCodes, giftIdToShowNoti) {
      this.__salepifyOfferIdsForNextNotification = (giftIdToShowNoti || []).map((giftId) => {
        const matchedItem = (items || []).find((item) => String(item.id) === String(giftId));
        const appliedRuleId = matchedItem && typeof this.detectAppliedRuleInLineItem === "function"
          ? this.detectAppliedRuleInLineItem({ properties: matchedItem.properties || {} })
          : null;

        return appliedRuleId ? String(appliedRuleId) : "";
      });

      return await originalHandleAddGifts.call(this, items, discountCodes, giftIdToShowNoti);
    };

    return true;
  };

  const timer = setInterval(() => {
    if (applyPatch()) clearInterval(timer);
  }, 300);
})();
